"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.reports.cost': 'Raporty Kosztów',
    'route.reports.shared': 'Udostępnione Rozmowy',
    'route.reports.cost.preview': 'Szczegóły Kosztów',
};
